export default __webpack_public_path__ + "static/banner-renovation-value-add-v1-92f1fd11b6dcf4fc3c3de9deb0a7763e.jpg";